import { render, staticRenderFns } from "./Sucursales.vue?vue&type=template&id=4b85e8bb&scoped=true"
import script from "./Sucursales.vue?vue&type=script&lang=js"
export * from "./Sucursales.vue?vue&type=script&lang=js"
import style0 from "./Sucursales.vue?vue&type=style&index=0&id=4b85e8bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b85e8bb",
  null
  
)

export default component.exports